export class UniformInfo {
    location: WebGLUniformLocation;
    type: number;

    constructor(location: WebGLUniformLocation, type: number) {
        this.location = location;
        this.type = type;
    }
}